/* THE CURRENT — the label's op-art field, living. Dots breathe on a slow
   sine, swell toward the cursor (the moire bulge tracking your hand), and
   pulse with scroll velocity. Canvas 2D, ~1k dots, IO-paused off-view,
   DPR-capped, pointer-transparent. Reduced-motion gets one static draw. */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mounts = document.querySelectorAll('[data-current]');
  if (!mounts.length) return;
  var scrollPulse = 0, lastY = window.scrollY;
  window.addEventListener('scroll', function () {
    var y = window.scrollY;
    scrollPulse = Math.min(1, Math.abs(y - lastY) / 220);
    lastY = y;
  }, { passive: true });

  mounts.forEach(function (host) {
    var color = host.getAttribute('data-current') || 'rgba(116,20,16,0.16)';
    var canvas = document.createElement('canvas');
    canvas.className = 'signyl-current';
    canvas.setAttribute('aria-hidden', 'true');
    host.insertBefore(canvas, host.firstChild);
    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
    var W = 0, H = 0, cols = 0, rows = 0, cell = 34;
    var mx = -9999, my = -9999, visible = false, raf = null, t = 0;

    function size() {
      var r = host.getBoundingClientRect();
      W = Math.ceil(r.width); H = Math.ceil(r.height);
      canvas.width = W * dpr; canvas.height = H * dpr;
      canvas.style.width = W + 'px'; canvas.style.height = H + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      cols = Math.ceil(W / cell) + 1; rows = Math.ceil(H / cell) + 1;
    }
    function draw() {
      ctx.clearRect(0, 0, W, H);
      ctx.fillStyle = color;
      var pulse = scrollPulse; scrollPulse *= 0.92;
      for (var r = 0; r < rows; r++) {
        for (var c = 0; c < cols; c++) {
          var x = c * cell + cell / 2, y = r * cell + cell / 2;
          var base = 1.1 + 2.4 * (Math.sin(c / 4.4) * Math.sin(r / 3.1) + 1) / 2;
          var breathe = reduced ? 0 : 0.6 * Math.sin(t * 0.9 + c * 0.55 + r * 0.4);
          var dx = x - mx, dy = y - my;
          var bump = reduced ? 0 : 7.5 * Math.exp(-(dx * dx + dy * dy) / 26000);
          var rad = Math.max(0.4, base + breathe + bump + base * pulse * 1.6);
          ctx.beginPath();
          ctx.arc(x, y, rad, 0, 6.2832);
          ctx.fill();
        }
      }
      t += 0.016;
      if (visible && !reduced) raf = requestAnimationFrame(draw);
    }
    host.addEventListener('pointermove', function (e) {
      var r = canvas.getBoundingClientRect();
      mx = e.clientX - r.left; my = e.clientY - r.top;
    });
    host.addEventListener('pointerleave', function () { mx = -9999; my = -9999; });
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        visible = e.isIntersecting;
        if (visible && !raf) { raf = requestAnimationFrame(draw); }
        if (!visible && raf) { cancelAnimationFrame(raf); raf = null; }
      });
    }, { threshold: 0.05 });
    io.observe(host);
    window.addEventListener('resize', function () { size(); if (reduced) draw(); }, { passive: true });
    size();
    draw();
    if (reduced && raf) { cancelAnimationFrame(raf); raf = null; }
  });
})();
